<div fxLayout="row" [hidden]="loading" fxLayoutGap="24px">
    <!--Header and search field-->
    <div fxLayout="column" style="height: 100%">
        <div fxLayout="row">
            <h2>PFT/CFT Scores</h2>
        </div>

        <div fxLayout="row">
            <mat-form-field>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" placeholder="Search" [formControl]="search" />
            </mat-form-field>

        </div>

        <!--selection list-->
        <mat-tab-group fxFlex="30">

            <!-- marines tab-->
            <mat-tab label="Marines">
                <ng-template matTabContent>
                    <cdk-virtual-scroll-viewport itemSize="50" style="height: 90vh;">
                        <mat-action-list>
                            <mat-list-item *cdkVirtualFor="let marine of marines | filterUsers: search.value"
                                (click)="selectMarine(marine)"
                                [ngClass]="{ selected: selectedMarine && selectedMarine.uuid === marine.uuid }">
                                <div fxLayout="column">
                                    <div matLine>
                                        <b>{{ marine.firstName + ' ' + marine.lastName }} </b>
                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-action-list>
                    </cdk-virtual-scroll-viewport>
                </ng-template>
            </mat-tab>

            <!--groups tab-->
            <mat-tab label="Groups" [disabled]="true">
                <ng-template matTabContent>
                    <cdk-virtual-scroll-viewport itemSize="50" style="height: 82vh;">
                        <mat-action-list>
                            <mat-list-item *cdkVirtualFor="let group of groups | filterGroups: search.value"
                                (click)="selectGroup(group)" [ngClass]="{ selected: selectedGroup === group }">
                                <div fxLayout="column">
                                    <div matLine>
                                        <b>{{ group.name }}</b>
                                    </div>
                                    <div [ngPlural]="group.members.length" matLine>
                                        <ng-template ngPluralCase="=1">{{ group.members.length }} member</ng-template>
                                        <ng-template ngPluralCase="other">{{ group.members.length }} members
                                        </ng-template>
                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-action-list>
                    </cdk-virtual-scroll-viewport>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <!--main screen-->
    <div fxFlex="70" fxLayout="column" style="height: 100%">
        <mat-spinner *ngIf="loading" diameter="48" mode="indeterminate" style="margin: 2rem auto;"></mat-spinner>

        <!--marines table-->
        <ng-container *ngIf="tabState === 0 && !loading">
            <!--User summary-->
            <div fxFlex="20" *ngIf="selectedMarine" class="user-summary">
                <div fxFlex="40" class="user-summary-item" fxLayout="column">
                    <h1 color="primary">{{selectedMarine.rank + ' ' + selectedMarine.firstName + ' ' +
                        selectedMarine.lastName}}
                    </h1>
                </div>
            </div>

            <div *ngIf="dataSourceIndividuals.data" fxLayout="row">
                <mat-spinner *ngIf="loadingPftScores || loadingCftScores" diameter="48" mode="indeterminate" style="margin: 2rem auto;"></mat-spinner>
                <div fxFlex="85" fxLayout="column">
                    <training-load-chart *ngIf="!loadingPftScores" fxFlex="100" [height]="'400px'" [seriesLabels]="pftSeriesLabels"
                        [lineSeries]="pftLineSeries" [lineLabel]="lineLabel" [thresholdValues]="thresholdValues" [thresholdColors]="thresholdColors"
                        [thresholdLabels]="thresholdLabels" [xLabel]="'Day'" [yLabel]="'PFT Scores'">
                    </training-load-chart>
                    <training-load-chart *ngIf="!loadingCftScores" fxFlex="100" [height]="'400px'" [seriesLabels]="cftSeriesLabels"
                        [lineSeries]="cftLineSeries" [lineLabel]="lineLabel" [thresholdValues]="thresholdValues" [thresholdColors]="thresholdColors"
                        [thresholdLabels]="thresholdLabels" [xLabel]="'Day'" [yLabel]="'CFT Scores'">
                    </training-load-chart>
                </div>
            </div>

        </ng-container>
    </div>
</div>
